import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './WixPortfolioCallToAction';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import {
  hasFirstTimeFlag,
  FirstTimeFlag,
  dropFirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { isCurrentUserProfileOwner } from '../../../selectors/users';
import { AppState } from '../../../../types/store';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';
import { getCurrentUserHasWixPortfolio } from '@wix/da-shared-react/pkg/publicSession';

export type StateProps = Pick<
  Props,
  'hasWixPortfolio' | 'isFirstTime' | 'isOwner' | 'isMobileFlagEnabled'
>;
export type DispatchProps = Pick<Props, 'onClickGetStarted' | 'onDismiss'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => ({
  isOwner: isCurrentUserProfileOwner(state),
  isFirstTime: hasFirstTimeFlag(state, FirstTimeFlag.IsPortfolioPopupNotClosed),
  isMobileFlagEnabled: flagEnabled(state, 'wix_portfolio_mobile'),
  hasWixPortfolio: Boolean(getCurrentUserHasWixPortfolio(state)),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  onClickGetStarted: () =>
    dispatch(pushModal(ModalType.WIX_PORTFOLIO_CREATE, { wrapInPopup: false })),
  onDismiss: () =>
    dispatch(
      dropFirstTimeFlag({
        flag: FirstTimeFlag.IsPortfolioPopupNotClosed,
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps);
